// extracted by mini-css-extract-plugin
module.exports = {"LoginCard":"LoginCard_LoginCard__QIQ_W"};